// extracted by mini-css-extract-plugin
export var label = "_dw-1";
export var reminder = "_dw-0";